window.theme = window.theme || {};

/* ================ SLATE ================ */
window.theme = window.theme || {};

window.theme.chevronRight = '<svg class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"></defs><path d="M223.18 628.49a35 35 0 0 1-24.75-59.75L388.17 379 198.43 189.26a35 35 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L247.93 618.24a34.89 34.89 0 0 1-24.75 10.25z" transform="translate(-188.18 -129.51)"/></svg>';
window.theme.chevronLeft = '<svg class="icon icon-chevron-left" viewBox="0 0 284.49 498.98"><path d="M437.67 129.51a35 35 0 0 1 24.75 59.75L272.67 379l189.75 189.74a35 35 0 1 1-49.5 49.5L198.43 403.75a35 35 0 0 1 0-49.5l214.49-214.49a34.89 34.89 0 0 1 24.75-10.25z" transform="translate(-188.18 -129.51)"/></svg>';

var mediaQuerySmall = 'screen and (max-width: 749px)';
var mediaQueryMediumUp = 'screen and (min-width: 750px)';

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (_.isUndefined(constructor)) {
      return;
    }

    var instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    this.instances = _.filter(this.instances, function(instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    // eslint-disable-next-line no-shadow
    var instance = _.find(this.instances, function(instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(
      function(index, container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  }
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13
  }
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    );
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on(
      'click',
      function(evt) {
        this.pageLinkFocus($(evt.currentTarget.hash));
      }.bind(this)
    );
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventsName = {
      focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
      focusout: options.namespace ? 'focusout.' + options.namespace : 'focusout',
      keydown: options.namespace ? 'keydown.' + options.namespace : 'keydown.handleFocus'
    };

    /**
     * Get every possible visible focusable element
     */
    var $focusableElements = options.$container.find(
      $('button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])').filter(':visible')
    );
    var firstFocusable = $focusableElements[0];
    var lastFocusable = $focusableElements[$focusableElements.length - 1];

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    function _manageFocus(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;

      /* On the last focusable element and tab forward, focus the first element. */
      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault();
        firstFocusable.focus();
      }
      /* On the first focusable element and tab backward, focus the last element. */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventsName.focusout, function() {
      $(document).off(eventsName.keydown);
    });

    $(document).on(eventsName.focusin, function(evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      $(document).on(eventsName.keydown, function(evt) {
        _manageFocus(evt);
      });
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {jQuery} options.$links - Specific links to be targeted
   */
  accessibleLinks: function(options) {
    var body = document.querySelector('body');

    var idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message'
    };

    if (options.$links === undefined || !options.$links.jquery) {
      options.$links = $('a:not([aria-describedby])');
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {};
      }

      var messages = $.extend(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.'
        },
        customMessages
      );

      var container = document.createElement('ul');
      var htmlMessages = '';

      for (var message in messages) {
        htmlMessages += '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
      }

      container.setAttribute('hidden', true);
      container.innerHTML = htmlMessages;

      body.appendChild(container);
    }

    function _externalSite($link) {
      var hostname = window.location.hostname;

      return $link[0].hostname !== hostname;
    }

    $.each(options.$links, function() {
      var $link = $(this);
      var target = $link.attr('target');
      var rel = $link.attr('rel');
      var isExternal = _externalSite($link);
      var isTargetBlank = target === '_blank';

      if (isExternal) {
        $link.attr('aria-describedby', idSelectors.external);
      }
      if (isTargetBlank) {
        if (rel === undefined || rel.indexOf('noopener') === -1) {
          $link.attr('rel', 'noopener');
        }
        $link.attr('aria-describedby', idSelectors.newWindow);
      }
      if (isExternal && isTargetBlank) {
        $link.attr('aria-describedby', idSelectors.newWindowExternal);
      }
    });

    generateHTML(options.messages);
  }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element); // eslint-disable-line callback-return
    } else {
      element.src = imageUrl;
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    );

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2];
      } else {
        return match[1];
      }
    } else {
      return null;
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    );
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function(element) {
          var $element = $(element);
          var type = $element.attr('type');
          var currentOption = {};

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val();
              currentOption.index = $element.data('index');

              return currentOption;
            } else {
              return false;
            }
          } else {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          }
        }
      );

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;

      var found = _.find(variants, function(variant) {
        return selectedValues.every(function(values) {
          return _.isEqual(variant[values.index], values.value);
        });
      });

      return found;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id;
      window.history.replaceState({ path: newurl }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    }
  });

  return Variants;
})();


/* ================ GLOBAL ================ */
/* Drawer modules*/
theme.Drawers = (function() {
  function Drawer(id, position, options) {
    var defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    };

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer')
    };

    this.config = $.extend(defaults, options);
    this.position = position;

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.drawerIsOpen = false;
    this.init();
  }

  Drawer.prototype.init = function() {
    $(this.config.open).on('click', $.proxy(this.open, this));
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this));
  };

  Drawer.prototype.open = function(evt) {
    // Keep track if drawer was opened from a click, or called by another function
    var externalCall = false;

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close();
    }

    // Add is-transitioning class to moved elements on open so drawer can have transition for close animation
    this.$drawer.prepareTransition();

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    );
    this.drawerIsOpen = true;

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen();
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    this.bindEvents();

    return this;
  };

  Drawer.prototype.close = function() {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition();

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    );

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false');
    }

    this.drawerIsOpen = false;

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    });

    this.unbindEvents();

    // Run function when draw closes if set
    if ( this.config.onDrawerClose && typeof this.config.onDrawerClose === 'function') {
      this.config.onDrawerClose();
    }
  };

  Drawer.prototype.bindEvents = function() {
    this.nodes.$parent.on('keyup.drawer',
      $.proxy(function(evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close();
          return false;
        } else {
          return true;
        }
      }, this)
    );

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function() {
      return false;
    });

    this.nodes.$page.on('click.drawer',
      $.proxy(function() {
        this.close();
        return false;
      }, this)
    );
  };

  Drawer.prototype.unbindEvents = function() {
    this.nodes.$page.off('.drawer');
    this.nodes.$parent.off('.drawer');
  };

  return Drawer;
})();


/* ================ MODULES ================ */
window.theme = window.theme || {};

theme.Header = (function() {
  var selectors = {
    body: 'body',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '.site-nav--has-dropdown',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last',
    meganav: '.meganav',
    meganavSidebarItem: '.meganav__sidebar-item',
    cartButton: '.top-bar__link--cart',
    cartDropdown: '.cart-dropdown-wrapper',
    announcementBar: '.announcement-bar',
    siteHeader: '.site-header',
    globalHeader: '#global-header'
  };

  var config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link'
  };

  var cache = {};

  function init() {
    cacheSelectors();

    cache.$parents.on('mouseenter.siteNav', function() {
      var $el = $(this);
      var dropShown = false;

      var dropShow = setTimeout(function(){
        showDropdown($el);
        dropShown = true;
      },100);

      $el.data('dropShow',dropShow);
      $el.mouseleave(function(dropshown){
        if(!dropShown) {
          clearTimeout($el.data('dropShow'));
        }
      });
    });

    cache.$parents.on('mouseleave.siteNav', function(e) {
      if(cache.$parents !== document.elementFromPoint(e.clientX, e.clientY)) { // ie click not actual mouseleave
        var $el = $(this);
        var dropHang = setTimeout(function() {
          hideDropdown($el);
        }, 10);

        $(selectors.meganav).data('dropHang',dropHang);
        $(selectors.meganav).mouseenter(function(){
          clearTimeout($(selectors.meganav).data('dropHang'));
        }); 
      }   
    });

    $(selectors.meganav).on('mouseenter.siteNav', function() {
      var $el = $(this).closest(selectors.siteNavHasDropdown);
      showDropdown($el);
    });

    $(selectors.meganav).on('mouseleave.siteNav', function(e) {
      if($(selectors.meganav) !== document.elementFromPoint(e.clientX, e.clientY)) { // ie click not actual mouseleave
        var $el = $(this).closest(selectors.siteNavHasDropdown);
        hideDropdown($el);
      }
    });

    // Meganav screen switching
    $(selectors.meganavSidebarItem).on('click.meganavSidebar',function(){
      var $thisMeganav = $(this).closest('.meganav');
      $thisMeganav.find('.meganav-screen').addClass('hide');
      $(this).siblings().removeClass('active-item');
      $(this).addClass('active-item');
      var thisScreen = '#' + $(this).data('screen');
      $(thisScreen).removeClass('hide');
    });

    // Cart Dropdown
    $(selectors.cartButton).hover(function() {
      $.getJSON('/cart.js', function(cart) {
        var atcSuccess = false;
        var atcAddedQty = 0;
        var cartItems = cart.items;
        fjUpdateCartDropdown(cartItems,atcSuccess,atcAddedQty);
      });
    },function(){
      var hangTime = 500;
      var cartHang = setTimeout(function(){
        fjCartDropdownClose();
      },hangTime);
      $('.cart-dropdown').data('cartHang',cartHang);
      $('.cart-dropdown').mouseenter(function(){
        clearTimeout($('.cart-dropdown').data('cartHang'));
      });
    });

    $('.cart-dropdown-wrapper').mouseleave(function(){
      if($('.small--hide').css('display') == 'block' || $('.medium-up--hide').css('display') == 'none') { // desktop
        fjCartDropdownClose();
      }
    });
    
    $('.cart-dropdown__close').click(function(){
      fjCartDropdownClose();
    });
    
    $('body').click(function(e){
      if($(this).hasClass('cart-dropdown-open')) {
        if(e.target.id !== "cart-dropdown" && $(e.target).closest('#cart-dropdown').length === 0) {
          fjCartDropdownClose();
        }
      }
    });

    // Chat links
    $('.trigger-chat').one('click',function(){
      fjLoadChat();
    });
    
    $('.trigger-chat').click(function(){
      $('body').addClass('chat-open');
    });

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function() {
      setTimeout(function() {
        if ($(document.activeElement).hasClass(config.childLinkClass) || !cache.$activeDropdown.length) {
          return;
        }

        hideDropdown(cache.$activeDropdown);
      });
    });

    // close dropdowns when on top level nav
    cache.$topLevel.on('focus.siteNav', function() {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown);
      }
    });

    cache.$subMenuLinks.on('click.siteNav', function(evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation();
    });
    
    // Sticky Mobile Header
    function stickyMobileHeader(){
      enquire.register(mediaQuerySmall, {
        match: function() {
          var scrollTop = $(window).scrollTop(),
              headerHeight = cache.$siteHeader.outerHeight(),
              announcementHeight = cache.$announcementBar.outerHeight() || 0;

          if (scrollTop >= announcementHeight) {
            cache.$siteHeader.addClass('site-header--fixed');
            cache.$globalHeader.css('padding-top',headerHeight);
          } else {
            cache.$siteHeader.removeClass('site-header--fixed');
            cache.$globalHeader.removeAttr('style');
          }        
        },
        unmatch: function() {
          cache.$siteHeader.removeClass('site-header--fixed');
          cache.$globalHeader.removeAttr('style');
        }
      });  
    }

    $(window).on('scroll.stickyMobileHeader resize.stickyMobileHeader', function() {
      stickyMobileHeader();
    }).trigger('scroll.stickyMobileHeader'); 
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown),
      $siteHeader: $(selectors.siteHeader),
      $announcementBar: $(selectors.announcementBar),
      $globalHeader: $(selectors.globalHeader)
    };
  }

  function showDropdown($el) {
    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown);
    }

    $el.addClass(config.activeClass);
    cache.$activeDropdown = $el;

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true');

    setTimeout(function() {
      $(window).on('keyup.siteNav', function(evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el);
        }
      });

      $(selectors.body).on('click.siteNav', function(e) {
        var targetClass = e.target.className;
        if(targetClass.indexOf('meganav') !== -1 && $(e.target).closest('.meganav').length === 0) {
          hideDropdown($el);
        }
      });
    }, 250);
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false');
    $el.removeClass(config.activeClass);

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown);

    $(selectors.body).off('click.siteNav');
    $(window).off('keyup.siteNav');
  }

  function unload() {
    $(window).off('.siteNav');
    cache.$parents.off('.siteNav');
    cache.$subMenuLinks.off('.siteNav');
    cache.$topLevel.off('.siteNav');
    $(selectors.siteNavChildLink).off('.siteNav');
    $(selectors.body).off('.siteNav');
    $(selectors.meganavSidebarItem).off('.meganav-sidebar');
  }

  return {
    init: init,
    unload: unload
  };
})();

window.theme = window.theme || {};

theme.MobileNav = (function() {
  var classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLinkWrapper: 'mobile-nav__item',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    fourthNavShowing: 'fourth-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  };
  var cache = {};
  var isTransitioning;
  var $activeSubNav;
  var $activeTrigger;
  var menuLevel = 1;

  function init() {
    cacheSelectors();

    cache.$mobileNavToggle.on('click', toggleMobileNav);
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav);

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function() {
        if (cache.$mobileNavContainer.hasClass(classes.navOpen)) {
          closeMobileNav();
        }
      }
    });
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav();
    } else {
      openMobileNav();
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContainer'),
      $siteHeader: $('.site-header'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $sectionHeader: $('#shopify-section-header'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
    };
  }

  function openMobileNav() {

    if ($('body').hasClass('search--open')) {
      theme.Search.searchDrawerClose();
    }

    var translateHeaderHeight = cache.$siteHeader.outerHeight() + $('.announcement-bar').outerHeight();

    cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen);
    
    var translatePageHeight = cache.$mobileNavContainer.css('height') || cache.$mobileNavContainer[0].scrollHeight;
   	translatePageHeight = translatePageHeight.replace('px','');

    cache.$mobileNavContainer.css({
      transform: 'translateY(' + translateHeaderHeight + 'px)'
    });

    cache.$pageContainer.css({
      transform:
        'translate3d(0, ' + translatePageHeight + 'px, 0)'
    });

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNavToggle,
      namespace: 'navFocus'
    });

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon)
      .attr('aria-expanded', true);

    // close on escape
    $(window).on('keyup.mobileNav', function(evt) {
      if (evt.which === 27) {
        closeMobileNav();
      }
    });
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen);

    cache.$mobileNavContainer.css({
      transform: 'translateY(-100%)'
    });

    cache.$pageContainer.removeAttr('style');

    slate.a11y.trapFocus({
      $container: $('html'),
      $elementToFocus: $('body')
    });

    cache.$mobileNavContainer.one(
      'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
      function() {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: 'navFocus'
        });
      }
    );

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon)
      .attr('aria-expanded', false)
      .focus();

    $(window).off('keyup.mobileNav');

    scrollTo(0, 0);
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return;
    }

    var $toggleBtn = $(evt.currentTarget);
    var isReturn = $toggleBtn.hasClass(classes.return);
    isTransitioning = true;
    
    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $('.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]').removeClass(classes.subNavActive);

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive);
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive);
    }

    $activeTrigger = $toggleBtn;

    goToSubnav($toggleBtn.data('target'));
  }

  function goToSubnav(target) {
    var $targetMenu = target ? $('.mobile-nav__dropdown[data-parent="' + target + '"]') : cache.$mobileNav;
    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1;

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav.prepareTransition().addClass(classes.subNavClosing);
    }
    $activeSubNav = $targetMenu;

    var translateMenuHeight = $targetMenu.outerHeight() + $('.mobile-nav__footer').outerHeight();

    //var openNavClass = menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing;
    var openNavClass = classes.subNavShowing;
    if(menuLevel === 3) {
      openNavClass = classes.thirdNavShowing;
    } else if(menuLevel === 4) {
      openNavClass = classes.fourthNavShowing;
    }

    cache.$mobileNavContainer
      .css('height', translateMenuHeight)
      .removeClass(classes.thirdNavShowing).removeClass(classes.fourthNavShowing)
      .addClass(openNavClass);

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing).removeClass(classes.fourthNavShowing)
        .removeClass(classes.subNavShowing);
    }

    /* if going back to first subnav, focus is on whole header */
    var $container = menuLevel === 1 ? cache.$sectionHeader : $targetMenu;

    var $menuTitle = $targetMenu.find('[data-menu-title=' + menuLevel + ']');
    var $elementToFocus = $menuTitle ? $menuTitle : $targetMenu;

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one(
      'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
      function() {
        slate.a11y.trapFocus({
          $container: $container,
          $elementToFocus: $elementToFocus,
          namespace: 'subNavFocus'
        });

        cache.$mobileNavContainer.off('.subnavToggle');
        isTransitioning = false;
      }
    );

    // Match height of subnav
    cache.$pageContainer.css({
      transform: 'translateY(' + translateMenuHeight + 'px)'
    });

    $activeSubNav.removeClass(classes.subNavClosing);
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav
  };
})(jQuery);

window.theme = window.theme || {};

theme.Search = (function() {
  var selectors = {
    search: '.search',
    searchSubmit: '.search-form__submit',
    searchInput: '.search-form__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-overlay',
    searchDrawerInput: '.search-form__input',

    searchHeader: '.search-form',
    searchHeaderInput: '.search-form__input',
    searchHeaderSubmit: '.search-form__submit',

    searchResultSubmit: '#SearchResultSubmit',
    searchResultInput: '#SearchInput',
    searchResultMessage: '[data-search-error-message]',

    mobileNavWrapper: '.mobile-nav-wrapper'
  };

  var classes = {
    open: 'search--open',
    focus: 'search--focus',
    hidden: 'hide',
    mobileNavIsOpen: 'js-menu--is-open'
  };

  function init() {
    if (!$(selectors.siteHeader).length) {
      return;
    }

    // Open Search Overlay
    $('.trigger-search').click(function(e){
      e.preventDefault();
      searchDrawerOpen();
    });

    // Close Search Overlay
    $('.search-overlay__close').click(function(){
      searchDrawerClose();
    });

    this.$searchResultInput = $(selectors.searchResultInput);
    this.$searchErrorMessage = $(selectors.searchResultMessage);

    var searchQuery = slate.utils.getParameterByName('q');

    if (searchQuery !== null && this.$searchResultInput.length) {
      validateSearchResultForm.call(this);
    }

    $(selectors.searchResultSubmit).on('click',validateSearchResultForm.bind(this));

    $(selectors.searchHeaderInput)
      .add(selectors.searchHeaderSubmit)
      .on('focus blur', function() {
        $(selectors.searchHeader).toggleClass(classes.focus);
      });

    $(selectors.siteHeaderSearchToggle).on('click', function() {
      var searchHeight = $(selectors.siteHeader).outerHeight();
      var searchOffset = $(selectors.siteHeader).offset().top - searchHeight;

      $(selectors.searchDrawer).css({
        height: searchHeight + 'px',
        top: searchOffset + 'px'
      });
    });
  }

  // function initDrawer() {
  //   // Add required classes to HTML
  //   $('#PageContainer').addClass('drawer-page-content');
  //   $('.js-drawer-open-top')
  //     .attr('aria-controls', 'SearchDrawer')
  //     .attr('aria-expanded', 'false')
  //     .attr('aria-haspopup', 'dialog');

  //   theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
  //     onDrawerOpen: searchDrawerFocus,
  //     onDrawerClose: searchDrawerFocusClose
  //   });
  // }

  function searchDrawerOpen() {
    $('.search-overlay').show();
    $('body').addClass(classes.open);
    searchDrawerFocus();
  }

  function searchDrawerClose() {
    $('.search-overlay').hide();
    $('body').removeClass(classes.open);
    searchDrawerFocusClose();
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput));

    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      theme.MobileNav.closeMobileNav();
    }
  }

  function searchFocus($el) {
    $el.focus();
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length);
  }

  function searchDrawerFocusClose() {
    $(selectors.siteHeaderSearchToggle).focus();
  }

  /**
   * Remove the aria-attributes and hide the error messages
   */
  function hideErrorMessage() {
    this.$searchErrorMessage.addClass(classes.hidden);
    this.$searchResultInput
      .removeAttr('aria-describedby')
      .removeAttr('aria-invalid');
  }

  /**
   * Add the aria-attributes and show the error messages
   */
  function showErrorMessage() {
    this.$searchErrorMessage.removeClass(classes.hidden);
    this.$searchResultInput
      .attr('aria-describedby', 'error-search-form')
      .attr('aria-invalid', true);
  }

  function validateSearchResultForm(evt) {
    var isInputValueEmpty = this.$searchResultInput.val().trim().length === 0;

    if (!isInputValueEmpty) {
      hideErrorMessage.call(this);
      return;
    }

    if (typeof evt !== 'undefined') {
      evt.preventDefault();
    }

    searchFocus(this.$searchResultInput);
    showErrorMessage.call(this);
  }

  return {
    init: init,
    searchDrawerClose: searchDrawerClose
  };
})();

(function() {
  var selectors = {
    backButton: '.return-link'
  };

  var $backButton = $(selectors.backButton);

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return;
  }

  $backButton.one('click', function(evt) {
    evt.preventDefault();

    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(window.location.href);

    if (shopDomain === referrerDomain) {
      history.back();
    }

    return false;
  });

  function urlDomain(url) {
    var anchor = document.createElement('a');
    anchor.ref = url;

    return anchor.hostname;
  }
})();

theme.Slideshow = (function() {
  this.$slideshow = null;
  var classes = {
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    video: 'slideshow__video',
    videoBackground: 'slideshow__video--background',
    closeVideoBtn: 'slideshow__video-control--close',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      //lazyLoad: ondemand,
      nextArrow: '.slideshow__arrow--next',
      prevArrow: '.slideshow__arrow--prev',
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed')
    };

    this.$slideshow.on('beforeChange', beforeChange.bind(this));
    this.$slideshow.on('init', slideshowA11y.bind(this));
    this.$slideshow.slick(this.settings);
  }

  function slideshowA11y(event, obj) {
    var $slider = obj.$slider;
    var $list = obj.$list;
    var $wrapper = this.$wrapper;
    var autoplay = this.settings.autoplay;

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live');

    // When an element in the slider is focused, pause slideshow and set aria-live.
    $wrapper.on('focusin', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.attr('aria-live', 'polite');

      if (autoplay) {
        $slider.slick('slickPause');
      }
    });

    // Resume autoplay
    $wrapper.on('focusout', function(evt) {
      if (!$wrapper.has(evt.target).length) {
        return;
      }

      $list.removeAttr('aria-live');

      if (autoplay) {
        $slider.slick('slickPlay');
      }
    });

    // Add arrow key support when focused
    if (obj.$dots) {
      obj.$dots.on('keydown', function(evt) {
        if (evt.which === 37) {
          $slider.slick('slickPrev');
        }

        if (evt.which === 39) {
          $slider.slick('slickNext');
        }

        // Update focus on newly selected tab
        if (evt.which === 37 || evt.which === 39) {
          obj.$dots.find('.slick-active button').focus();
        }
      });
    }
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    var $slider = slick.$slider;
    var $nextSlideImage = $slider.find('[data-slick-index="' + nextSlide + '"] .slideshow__image');
    
    if(!$nextSlideImage.hasClass('lazyloaded')){
      $nextSlideImage.addClass('lazyload');
    }
  }

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id');
  }

  return slideshow;
})();

window.theme = window.theme || {};

theme.FormStatus = (function() {
  var selectors = {
    statusMessage: '[data-form-status]'
  };

  function init() {
    this.$statusMessage = $(selectors.statusMessage);

    if (!this.$statusMessage) return;

    this.$statusMessage.focus();
  }

  return {
    init: init
  };
})();


/* ================ TEMPLATES ================ */
(function() {
  var $filterBy = $('#BlogTagFilter');

  if (!$filterBy.length) {
    return;
  }

  $filterBy.on('change', function() {
    location.href = $(this).val();
  });
})();

window.theme = theme || {};

theme.customerTemplates = (function() {
  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      );
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        });
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();


/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
  var selectors = {
    edit: '.js-edit-toggle',
    inputQty: '.cart__qty-input',
    thumbnails: '.cart__image',
    item: '.cart__row'
  };

  var config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  };

  function Cart(container) {
    this.$container = $(container);
    this.$edit = $(selectors.edit, this.$container);
    this.$inputQuantities = $(selectors.inputQty, this.$container);
    this.$thumbnails = $(selectors.thumbnails, this.$container);

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies);
    }

    this.$edit.on('click', this._onEditClick);
    this.$inputQuantities.on('change', this._handleInputQty);

    this.$thumbnails.css('cursor', 'pointer');
    this.$thumbnails.on('click', this._handleThumbnailClick);
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function() {
      this.$edit.off('click', this._onEditClick);
    },

    _onEditClick: function(evt) {
      var $evtTarget = $(evt.target);
      var $updateLine = $('.' + $evtTarget.data('target'));
      var isExpanded = $evtTarget.attr('aria-expanded') === 'true';

      $evtTarget
        .toggleClass(config.showEditClass)
        .attr('aria-expanded', !isExpanded);
      $updateLine.toggleClass(config.showClass);
    },

    _handleInputQty: function(evt) {
      var $input = $(evt.target);
      var value = $input.val();
      var itemKey = $input.data('quantity-item');
      var $itemQtyInputs = $('[data-quantity-item=' + itemKey + ']');
      $itemQtyInputs.val(value);
    },

    _handleThumbnailClick: function(evt) {
      var url = $(evt.target).data('item-url');

      window.location.href = url;
    },

    cookiesEnabled: function() {
      var cookieEnabled = navigator.cookieEnabled;

      if (!cookieEnabled) {
        document.cookie = 'testcookie';
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
      }
      return cookieEnabled;
    }
  });

  return Cart;
})();

window.theme = window.theme || {};

theme.SortCollection = (function() {
  var settings = {
    mediaQueryMediumUp: 'screen and (min-width: 750px)'
  };

  var constants = {
    SORT_BY: 'sort_by'
  };

  var selectors = {
    mainContent: '#MainContent',
    sortSelection: '#SortBy',
    defaultSort: '#DefaultSortBy'
  };

  function SortCollection(container) {
    var $container = (this.$container = $(container));
    this.$sortSelect = $(selectors.sortSelection, $container);
    this.defaultSort = this._getDefaultSortValue();
    this.$sortSelect.removeClass('hidden');
    this.$sortSelect.on('change', this._onSortChange.bind(this));
  }

  SortCollection.prototype = _.assignIn({}, SortCollection.prototype, {

    _onSortChange: function() {
      var sort = this._sortValue();
      var url = window.location.href.replace(window.location.search, '');

      if (sort.length) {
        var urlStripped = url.replace(window.location.hash, '');
        window.location.href = urlStripped + '?' + sort + selectors.mainContent;
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = url;
      }
    },

    _getSortValue: function() {
      return this.$sortSelect.val() || this.defaultSort;
    },

    _getDefaultSortValue: function() {
      return $(selectors.defaultSort, this.$container).val();
    },

    _sortValue: function() {
      var sort = this._getSortValue();
      var query = '';

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort;
      }

      return query;
    },

    onUnload: function() {
      this.$sortSelect.off('change', this._onSortChange);
    }
  });

  return SortCollection;
})();

window.theme = window.theme || {};

theme.HeaderSection = (function() {
  function Header() {
    theme.Header.init();
    theme.MobileNav.init();
    theme.Search.init();
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function() {
      theme.Header.unload();
    }
  });

  return Header;
})();


theme.Product = (function() {
  function Product(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');

    this.settings = {
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      mainSliderActive: false,
      sliderActive: false,
      zoomEnabled: false
    };

    this.selectors = {
      atcForm: '.product-form-' + sectionId,
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      errorQuantityMessage: '#error-quantity-' + sectionId,
      quantity: '#Quantity-' + sectionId,
      SKU: '.variant-sku--'+sectionId,
      productStatus: '[data-product-status]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productMainImgs: '.product-single__main-photos--'+ sectionId,
      productImageWraps: '.product-single__photo',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails--' + sectionId,
      productFeaturedImage: '.product-featured-img',
      productThumbsWrapper: '.thumbnails-wrapper',
      saleLabel: '.product-price__sale-label-' + sectionId,
      productOptions: '.product-form__options-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      shopifyPaymentButton: '.shopify-payment-button',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]'
    };

    this.classes = {
      hidden: 'hide',
      productOnSale: 'price--on-sale',
      productUnavailable: 'price--unavailable'
    };

    // Stop parsing if we don't have the product json script tag when loading section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      console.log('cant find product json');
      return;
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    );

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      'js-zoom-enabled'
    );

    this._initBreakpoints();
    this._stringOverrides();
	this._initImageSwitch();
    this._initVariants(); 
	this._setActiveThumbnail();
    this._initAddToCart();

    // if($(this.selectors.productThumbs).children().length <= 6) {
    //   this._initImageSwitch();
    //   this._setActiveThumbnail();
    // }

    // if($(this.selectors.productMainImgs).hasClass('product-main-slider')){
    //   this._initMainSlider();
    // }

    // Ajax Add to Cart
    var self = this;
    $('body').on('click',this.selectors.addToCart,function(e){
      e.preventDefault();
      var formData = $(self.selectors.atcForm).serialize();
      var atcAddedQty = parseInt($(self.selectors.atcForm).find('[name="quantity"]').val());
      fjAjaxAdd(formData,atcAddedQty);
    });
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    _initBreakpoints: function() {
      var self = this;

      enquire.register(this.settings.mediaQuerySmall, {
        match: function() {
          //initialize thumbnail slider on mobile if more than 4 thumbnails
          // if ($(self.selectors.productThumbImages).length > 4) {
          //  self._initThumbnailSlider();
          // }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _destroyZoom(this);
            });
          }

          self.settings.bpSmall = true;
        },
        unmatch: function() {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider();
          }

          self.settings.bpSmall = false;
        }
      });

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function() {
          //self._initThumbnailSlider();

          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function() {
              _enableZoom(this);
            });
          }
        }
      });
    },

    _initVariants: function() {
      var self = this;
      var options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      };

      this.variants = new slate.Variants(options);

      // init sliders
      if($(this.selectors.productMainImgs).hasClass('product-main-slider')){
        var startSlideIndex = 0;
        var startSlideId = null;

        if(this.variants.currentVariant.featured_image !== null) {
          startSlideIndex = $(this.selectors.productMainImgs).find('[data-img-id="'+this.variants.currentVariant.featured_image.id+'"]').data('slide-index');
          startSlideId = this.variants.currentVariant.featured_image.id;
        }

        if($(this.selectors.productMainImgs).hasClass('product-main-slider')){
          this._initMainSlider(startSlideIndex,startSlideId);
        
          enquire.register(this.settings.mediaQueryMediumUp, {
            match: function() {
              self._initThumbnailSlider(startSlideIndex);
            },
            unmatch: function() {
              if (self.settings.sliderActive) {
                self._destroyThumbnailSlider();
              }
            }
          });
        }
      }

      this.$container.on('variantChange' + this.settings.namespace,this._updateAvailability.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace,this._updateImages.bind(this));
      this.$container.on('variantPriceChange' + this.settings.namespace,this._updatePrice.bind(this));
      this.$container.on('variantSKUChange' + this.settings.namespace,this._updateSKU.bind(this));
    },

    _initImageSwitch: function() {
      if (!$(this.selectors.productThumbImages).length) {
        return;
      }

      var self = this;

      $(this.selectors.productThumbImages).on('click', function(evt) {
        evt.preventDefault();
        var $el = $(this);
        var imageId = $el.data('thumbnail-id');
        self._switchImage(imageId);
        self._setActiveThumbnail(imageId);       
      }).on('keyup', self._handleImageFocus.bind(self));
    },

    _initAddToCart: function() {
      var self = this;
      var $quantityInput = $(self.selectors.quantity);

      if ($quantityInput.length === 0) return;

      $(self.selectors.addToCart).on('click', function(evt) {
        var isInvalidQuantity = $quantityInput.val() <= 0;

        $(self.selectors.errorQuantityMessage).toggleClass(
          self.classes.hidden,
          !isInvalidQuantity
        );

        if (isInvalidQuantity) {
          $quantityInput.attr('aria-describedby','error-quantity-' + self.settings.sectionId).attr('aria-invalid', true);
          $(self.selectors.errorQuantityMessage).focus();
          evt.preventDefault();
        } else {
          $quantityInput.removeAttr('aria-describedby').removeAttr('aria-invalid');
        }
      });
    },

    _setActiveThumbnail: function(imageId) {
      var activeClass = 'active-thumb';

      // If there is no element passed, find it by the current product image
      if (typeof imageId === 'undefined') {
        imageId = $(this.selectors.productImageWraps).data('image-id');
      }

      var $thumbnail = $(
        this.selectors.productThumbImages + "[data-thumbnail-id='" +imageId +"']"
      );

      if($(this.selectors.productMainImgs).hasClass('product-main-slider')){
        var slideIndex = $thumbnail.closest('.slick-slide').data('slick-index');
        $(this.selectors.productThumbs).slick('slickGoTo',slideIndex);
      } else {

        $(this.selectors.productThumbImages).removeClass(activeClass).removeAttr('aria-current');

        $thumbnail.addClass(activeClass);
        $thumbnail.attr('aria-current', true);
      }
    },

    _switchImage: function(imageId) {
      var $newImage = $(
        this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
        this.$container
      );

      if($(this.selectors.productMainImgs).hasClass('product-main-slider')){
        var slideIndex = $newImage.closest('.slick-slide').data('slick-index');
        $(this.selectors.productMainImgs).slick('slickGoTo',slideIndex);
      } else {
        var $otherImages = $(this.selectors.productImageWraps + ":not([data-image-id='" + imageId + "'])", this.$container);

        $newImage.removeClass(this.classes.hidden);
        $otherImages.addClass(this.classes.hidden);
      }

    },

    _handleImageFocus: function(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

      $(this.selectors.productFeaturedImage + ':visible').focus();
    },

    _initMainSlider: function(startSlideIndex, imageId) {
      var self = this;
      var startSlide = parseInt(startSlideIndex);
      var asNavFor = null;

      //console.log('startSlideId '+imageId);

      //if($(this.selectors.productThumbs).children().length > 6) {
        asNavFor = this.selectors.productThumbs;
      //} else {
      //  this._setActiveThumbnail(imageId);
      //}

      var options = {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        adaptiveHeight: true,
        focusOnSelect: true,
        initialSlide: startSlide,
        fade: true,
        //asNavFor: asNavFor,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              dots: true,
              asNavFor: null
            }
          }
        ]
      };

      //console.log(this.selectors.productMainImgs);
      $(this.selectors.productMainImgs).slick(options);
      //$mainSlider.slick('slickGoTo',startSlide);
      //$('.product-single__thumbnails .thumb-slide[data-slide-index="'+startSlide+'"]').click();
      
      $('.mobile-360').click(function(){
        var slideIndex = $(this).data('slide-index');
        if($(this).hasClass('mobile-360--active')) {
          slideIndex = 0;
        }
        $(self.selectors.productMainImgs).slick('slickGoTo',slideIndex);
        $(this).toggleClass('mobile-360--inactive mobile-360--active');
      });

      $('.mobile-360-close').click(function(){
        var slideIndex = 0;
        $(self.selectors.productMainImgs).slick('slickGoTo',slideIndex);
        if($('.mobile-360').hasClass('mobile-360--active')){
          $('.mobile-360').toggleClass('mobile-360--inactive mobile-360--active');
        }
      });

      // Accessibility concerns not yet fixed in Slick Slider
      // $(this.selectors.productThumbsWrapper, this.$container)
      //   .find('.slick-list')
      //   .removeAttr('aria-live');
      // $(this.selectors.productThumbsWrapper, this.$container)
      //   .find('.slick-disabled')
      //   .removeAttr('aria-disabled');

      this.settings.mainSliderActive = true;
    },

    _destroyMainSlider: function() {
      $(this.selectors.productMainImgs).slick('unslick');
      this.settings.mainSliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      // $(this.selectors.productThumbsWrapper, this.$container)
      //   .find('[tabindex="-1"]')
      //   .removeAttr('tabindex');
    },


    _initThumbnailSlider: function(startSlideIndex) {
      var self = this;

      var slidesToShow = 6;

      var options = {
        slidesToShow: slidesToShow,
        slidesToScroll: 1,
        infinite: false,
        vertical: true,
        focusOnSelect: true,
        //initialSlide: startSlideIndex,
        asNavFor: this.selectors.productMainImgs,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: slidesToShow,
              vertical: false
            }
          }
        ]
      };

      if(startSlideIndex !== 0) {
        $(this.selectors.productThumbs).on('init', function(slick){
          $(self.selectors.productThumbs + ' .slick-current').removeClass('slick-current');
          $(self.selectors.productThumbs + ' [data-slick-index="'+startSlideIndex+'"]').addClass('slick-current');
        });
      }

      $(this.selectors.productThumbs).slick(options);

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container).find('.slick-list').removeAttr('aria-live');
      $(this.selectors.productThumbsWrapper, this.$container).find('.slick-disabled').removeAttr('aria-disabled');

      this.settings.sliderActive = true;
    },

    _destroyThumbnailSlider: function() {
      $(this.selectors.productThumbs).slick('unslick');
      this.settings.sliderActive = false;

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container).find('[tabindex="-1"]').removeAttr('tabindex');
    },

    _liveRegionText: function(variant) {
      // Dummy content for live region
      var liveRegionText = '[Availability] [Regular] [$$] [Sale] [$]';

      if (!variant) {
        liveRegionText = theme.strings.unavailable;
        return liveRegionText;
      }

      // Update availability
      var availability = variant.available ? '' : theme.strings.soldOut + ',';
      liveRegionText = liveRegionText.replace('[Availability]', availability);

      // Update pricing information
      var regularLabel = '';
      var regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      );
      var saleLabel = '';
      var salePrice = '';

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice;
        regularPrice =
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ',';
        saleLabel = theme.strings.sale;
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        );
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .trim();

      return liveRegionText;
    },

    _updateLiveRegion: function(evt) {
      var variant = evt.variant;
      var liveRegion = this.container.querySelector(
        this.selectors.productStatus
      );
      liveRegion.textContent = this._liveRegionText(variant);
      liveRegion.setAttribute('aria-hidden', false);

      // hide content from accessibility tree after announcement
      setTimeout(function() {
        liveRegion.setAttribute('aria-hidden', true);
      }, 1000);
    },

    _updateAddToCart: function(evt) {
      var variant = evt.variant;

      $(this.selectors.productOptions).find('.option-error').remove();
      $(this.selectors.singleOptionSelector).removeClass('input--error');
      $('.swatch-option__input').removeClass('input--error');

      var apptUrl = $('.appt-btn',this.selectors.atcForm).attr('href');
      var apptUrlWithoutSKU = apptUrl.substring(0,apptUrl.indexOf('&sku=')+5);

      if (variant) {
        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false);
        } else {
          $(this.selectors.addToCart).prop('disabled', true);
          $(this.selectors.productOptions).append('<div class="option-error product-form__option">'+theme.strings.soldOut+'</div>');
          $(this.selectors.singleOptionSelector).addClass('input--error');
          $('.swatch-option__input:checked').addClass('input--error');
        }
        var newApptUrl = apptUrlWithoutSKU + encodeURIComponent(variant.sku);
        $('.appt-btn',this.selectors.atcForm).attr('href',newApptUrl);
      } else {
        $(this.selectors.addToCart).prop('disabled', true);
        $(this.selectors.productOptions).append('<div class="option-error product-form__option">'+theme.strings.unavailable+'</div>');
        $(this.selectors.singleOptionSelector).addClass('input--error');
        $('.appt-btn',this.selectors.atcForm).attr('href',apptUrlWithoutSKU);
      }
    },

    _updateAvailability: function(evt) {
      // update form submit
      this._updateAddToCart(evt);
      // update live region
      this._updateLiveRegion(evt);

      this._updatePrice(evt);
    },

    _updateImages: function(evt) {
      console.log('updateImages?');
      var variant = evt.variant;
      var imageId = variant.featured_image.id;

      this._switchImage(imageId);
      this._setActiveThumbnail(imageId);
    },

    _updatePrice: function(evt) {
      var variant = evt.variant;

      var $priceContainer = $(this.selectors.priceContainer, this.$container);
      var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
      var $salePrice = $(this.selectors.salePrice, $priceContainer);

      // Reset product price state
      $priceContainer.removeClass(this.classes.productUnavailable).removeClass(this.classes.productOnSale).removeAttr('aria-hidden');

      // Unavailable
      if (!variant) {
        $priceContainer.addClass(this.classes.productUnavailable).attr('aria-hidden', true);
        return;
      }

      // On sale
      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          )
        );
        $salePrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
        $priceContainer.addClass(this.classes.productOnSale);
      } else {
        // Regular price
        $regularPrice.html(
          theme.Currency.formatMoney(variant.price, theme.moneyFormat)
        );
      }

      // Update Affirm
      $('.affirm-as-low-as',this.$container).attr('data-amount',variant.price);
      affirm.ui.refresh();
    },

    _updateSKU: function(evt) {
      var variant = evt.variant;

      if(variant.sku !== null) {
        $(this.selectors.SKU).text(variant.sku);
        $(this.selectors.SKU).parent().removeClass('hide');
      } else {
        $(this.selectors.SKU).text('');
        $(this.selectors.SKU).parent().addClass('hide');
      }
      
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
    }
  });

  function _enableZoom(el) {
    var zoomUrl = $(el).data('zoom');
    $(el).zoom({
      url: zoomUrl
    });
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy');
  }

  return Product;
})();


theme.Logos = (function() {
  var config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  };
  var defaults = {
    accessibility: true,
    arrows: true,
    dots: false,
    autoplay: false,
    infinite: false,
    touchThreshold: 20,
    slidesToShow: 7,
    slidesToScroll: 7,
    nextArrow: '<button title="Next" class="item-slider__arrow item-slider__arrow--next">'+theme.chevronRight+'</button>',
    prevArrow: '<button title="Previous" class="item-slider__arrow item-slider__arrow--prev">'+theme.chevronLeft+'</button>',
  };

  function Logos(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var wrapper = (this.wrapper = '.logo-bar-wrapper');
    var slider = (this.slider = '#Logos-' + sectionId);
    var $slider = $(slider, wrapper);

    var sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 3,
      slidesToScroll: 3,
      dots: true
    });

    config.slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount;
      defaults.slidesToScroll = config.slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    enquire.register(config.mediaQuerySmall, {
      match: function() {
        initSlider($slider, mobileOptions);
      }
    });

    enquire.register(config.mediaQueryMediumUp, {
      match: function() {
        initSlider($slider, defaults);
      }
    });

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick');
        sliderActive = false;
      }

      sliderObj.slick(args);
      sliderActive = true;
    }
  }

  Logos.prototype = _.assignIn({}, Logos.prototype, {
    onUnload: function() {
      enquire.unregister(config.mediaQuerySmall);
      enquire.unregister(config.mediaQueryMediumUp);

      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $(
        '.logo-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Logos;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
  function SlideshowSection(container) {
    var $container = (this.$container = $(container));
    var sectionId = $container.attr('data-section-id');
    var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

    $('.slideshow__video', slideshow).each(function() {
      var $el = $(this);
      theme.SlideshowVideo.init($el);
      theme.SlideshowVideo.loadVideo($el.attr('id'));
    });

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow);
  }

  return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function() {
      delete theme.slideshows[this.slideshow];
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      );
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      // Resume autoplay
      $(this.slideshow).slick('slickPlay');
    }
  }
);


$(document).ready(function() {
  var sections = new theme.Sections();

  sections.register('cart-template', theme.Cart);
  sections.register('product', theme.Product);
  sections.register('collection-template', theme.SortCollection);
  sections.register('product-template', theme.Product);
  sections.register('header-section', theme.HeaderSection);
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('logos', theme.Logos);
});

theme.init = function() {
  // Rolex iframe
  var rolexBadgeIframe = '<iframe class="rolex-badge" src="https://static.rolex.com/retailers/clock/?colour=gold&apiKey=89d3db5caaa5e88f92427f76d6a936a1&lang=en_us" id="rolex-clock" scrolling="no"></iframe>';
  enquire.register(mediaQueryMediumUp, {
    match: function() {
      $('.site-header .rolex-badge-link').append(rolexBadgeIframe);
    },
    unmatch: function() {
      $('.site-header .rolex-badge-link').html('');
    }
  });
  
  theme.customerTemplates.init();

  // Theme-specific selectors to make tables scrollable
  var tableSelectors = '.rte table,' + '.custom__item-inner--html table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper'
  });

  // Theme-specific selectors to make iframes responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'video-wrapper'
  });

  if($('.rte iframe[src*="stream.iconasys"]').length){
    var iframeWidth = $('.rte iframe[src*="stream.iconasys"]').attr('width');
    var iframeHeight = $('.rte iframe[src*="stream.iconasys"]').attr('height');
    var padding = (iframeHeight / iframeWidth) * 100;
    $('.rte iframe[src*="stream.iconasys"]').wrap('<div class="custom-video-wrapper" style="padding-bottom:'+padding+'%;"></div>');
  }

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  $('a[href="#"]').on('click', function(evt) {
    evt.preventDefault();
  });

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal
    },
    $links: $('a:not([aria-describedby], .product-single__thumbnail)')
  });

  theme.FormStatus.init();

  /*----------- CUSTOM -----------*/
  enquire.register(mediaQuerySmall, {
    match: function() {
      $('.footer-column--menu .footer-column__title').on('click.footer',function(){
        console.log('footer column title clicked');
        $(this).next('.footer-menu').slideToggle();
        $(this).parent().toggleClass('footer-menu--closed footer-menu--open');
      });

      $('.filter-group__title').click(function(){
        var $filterParent = $(this).parent();
        var $filterContent = $(this).next('.filter-group__content'); 
        $filterContent.slideToggle(function(){
          $filterParent.toggleClass('filter-open');
        });
      });
    },
    unmatch: function() {
      $('.footer-column--menu .footer-column__title').off('click.footer');
    }
  });

  $('body').on('click','.animate-anchor',function(e){
    fjAnimateAnchor(e,this);
  });

  // Content Expander
  $('.content-toggle').click(function(e){
    e.preventDefault();
    var link = this;
    fjContentToggle(link);
  });

  // Small item slider
 /* $('.item-slider.item-slider--small:not(".slick-initialized")').slick({
    infinite: false,
    slidesToShow: 8,
    slidesToScroll: 8,
    //adaptiveHeight: true,
    //lazyLoad: 'ondemand',
    arrows: true,
    dots: true,
    nextArrow: '<button title="Next" class="item-slider__arrow item-slider__arrow--next">'+theme.chevronRight+'</button>',
    prevArrow: '<button title="Previous" class="item-slider__arrow item-slider__arrow--prev">'+theme.chevronLeft+'</button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      }
    ]
  });
*/
  // Product Card slider
  if($('.item-slider:not(".item-slider--small")').length){
    fjItemSlider();
  }

  // Location page slider
 /* $('.location-slider:not(".slick-initialized")').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    dots: true,
    nextArrow: '<button title="Next" class="item-slider__arrow item-slider__arrow--next">'+theme.chevronRight+'</button>',
    prevArrow: '<button title="Previous" class="item-slider__arrow item-slider__arrow--prev">'+theme.chevronLeft+'</button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false
        }
      }
    ]
  }); */

  // Reveal Social Share Icons
  $('.trigger-social').click(function(){
    $(this).hide();
    $(this).next('.social-icons').fadeIn();
  });

  // Open Quick View
  fjQuickViewOpen();

  // Product Card Swatch / Image Switching
  fjProductCardSwatches();

  // Email validation
  function validEmail(value){return /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i.test(value);};

  // Locations Form Dropdown
  if($('#store-locations-select').length){
    $.get('/pages/'+theme.locationsDirectory+'?view=locations-data', function(locationsData) {
      locationsData = locationsData.replace('<div id="shopify-section-locations-directory" class="shopify-section location-page">','').replace('</div>','');
      var locations = JSON.parse(locationsData);
      for (i = 0; i < locations.length; i++){
        var locationOption = '<option value="'+locations[i].location+'">'+locations[i].location+'</option>';
        $('#store-locations-select').append(locationOption);
      }

      var currentUrl = window.location.href;
      var locationIndex = currentUrl.indexOf('location=');
      if(locationIndex !== -1) {
        var location = decodeURIComponent(currentUrl.substring(locationIndex + 9));
        $('#store-locations-select').val(location).trigger('change');
      }
    });
  }

  // Appt Form pre-populate product
  if($('#ApptForm').length){
    var currentUrl = window.location.href;
    var productUrlIndex = currentUrl.indexOf('product=');
    var variantUrlIndex = currentUrl.indexOf('&variant=');
    if(productUrlIndex !== -1) {
      if(variantUrlIndex !== -1) {
        var productTitle = decodeURIComponent(currentUrl.substring(productUrlIndex + 8,variantUrlIndex));
        var variantTitle = decodeURIComponent(currentUrl.substring(variantUrlIndex + 9));
        $('#ApptForm').append('<input type="hidden" name="contact[Clicked from product]" value="'+productTitle+' (variant: '+variantTitle +')" />');
      } else {
        var productTitle = decodeURIComponent(currentUrl.substring(productUrlIndex + 8));
        $('#ApptForm').append('<input type="hidden" name="contact[Clicked from product]" value="'+productTitle+'" />');
      }     
    }
  }

  // Klaviyo Footer Sign Up Form
  $('.site-footer__newsletter input[type="email"]').one('focus',function(){
    $('body').append('<script type="text/javascript" src="//www.klaviyo.com/media/js/public/klaviyo_subscribe.js"></script');
    var klaviyoInterval = window.setInterval(function () {
      if (typeof KlaviyoSubscribe !== 'undefined') {
        window.clearInterval(klaviyoInterval);
        KlaviyoSubscribe.attachToForms("#email_signup", {
          hide_form_on_success: false,
          extra_properties: {
            $source: "$embed",
            $method_type: "Klaviyo Form",
            $method_id: "embed",
          }
        });
      }
    }, 100);
  });
  
  // Cart popup
  function fjCartPopup(btnText){
    var cartPopupHtml = '<div class="cart-popup">'+theme.strings.cartPopup+' <div class="text-center"><button class="btn" data-fancybox-close style="min-width:100px;">'+btnText+'</button></div></div>';
    return cartPopupHtml;
  }
    
  $('.cart-dropdown__checkout-btn').click(function(e){
    e.preventDefault();
    var cartPopupShown = localStorage.getItem('finks_cart_popup_shown') || false;
    var linkUrl = $(this).attr('href');
    var cartTotal = $('.cart-dropdown__total-price').text().replace('$','').replace(',','');
    if(!cartPopupShown && parseFloat(cartTotal) >= 2500){
      var cartPopupBtnText = 'Ok, proceed.';
      var cartDropdownPopup = fjCartPopup(cartPopupBtnText);      
      $.fancybox.open({
        touch: false,
        autoFocus: false,
        type: 'inline',
        src: cartDropdownPopup,
        afterClose: function(){
          localStorage.setItem('finks_cart_popup_shown',true)
          window.location = linkUrl;
        }
      });
    } else {
      window.location = linkUrl;
    } 
  });

};

$(theme.init);

function fjItemSlider(){
  $('.item-slider:not(".slick-initialized")').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 4,
    adaptiveHeight: true,
    lazyLoad: 'ondemand',
    nextArrow: '<button title="Next" class="item-slider__arrow item-slider__arrow--next">'+theme.chevronRight+'</button>',
    prevArrow: '<button title="Previous" class="item-slider__arrow item-slider__arrow--prev">'+theme.chevronLeft+'</button>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 750,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 550,
        settings: {
          arrows: false,
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 2
        }
      }
    ]
  });
}

// Ajax Add To Cart, Cart Dropdown
function fjUpdateCartDropdown(cartItems,atcSuccess,atcAddedQty){
  if(cartItems.length !== 0) {
    $('.cart-dropdown__items').html('');
    for (i = 0; i < cartItems.length; i++){
      var item = cartItems[i];
      var itemImg = item.image || '';
      itemImg = itemImg.replace(/(\.[^.]*)$/, "_100x100$1");
      var itemPrice = theme.Currency.formatMoney(item.price,theme.moneyFormat);
      var itemHtml = '<tr class="cart-item"><td class="cart-item__image"><div class="product-card__img-wrapper"><a href="'+item.url+'" class="product-card__img-link"><img class="product-card__img" src="'+itemImg+'"></a></div></td><td class="cart-item__product"><a class="cart-item__title" href="'+item.url+'">'+item.product_title+'</a></div></td><td class="cart-item__price">'+itemPrice+'</td></tr>';
      $('.cart-dropdown__items').append(itemHtml);
    }
    $('.cart-item__empty, .cart-dropdown .form-message').remove();
    $('.cart-dropdown__footer').removeClass('hide');
  }
  if(atcSuccess) {
    var itemPlural = (atcAddedQty === 1) ? '':'s';
    $('.cart-dropdown__header').append('<div class="form-message form-message--success text-center"><span class="form-message__icon"></span> '+ atcAddedQty + ' item'+ itemPlural +' successfully added to your cart</div>');
  }
  
  fjCartDropdownOpen(atcSuccess);
}

function fjUpdateCartData(cartQty,cartTotal){
  $('header .cart-link').removeClass('cart--empty').addClass('cart--full');
  $('header .cart-count').text(cartQty);
  $('.cart-dropdown__total-price').text(cartTotal);
}

function fjAjaxAddSuccess(atcSuccess,atcAddedQty){
  localStorage.removeItem('finks_cart_popup_shown');
  fjTriggerModalClose();
  if($('body').hasClass('template-cart')) {
    location.reload();
  } else {
    $.ajax({
      type: 'GET',
      url: '/cart.js',
      dataType: 'json',
      success: function(cart) {
        var cartItems = cart.items;
        var cartQty = cart.item_count;
        var cartTotal = theme.Currency.formatMoney(cart.total_price,theme.moneyFormat);
        fjUpdateCartData(cartQty,cartTotal);
        fjUpdateCartDropdown(cartItems,atcSuccess,atcAddedQty);
      }
    });
  }
}

function fjAjaxAdd(formData,atcAddedQty){
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: formData,
    dataType: 'json',
    success: function(item){
      var atcSuccess = true;
      fjAjaxAddSuccess(atcSuccess,atcAddedQty);
    },
    error: function(response){
      console.log(response);
      if(response.status == 422){
        alert(response.responseJSON.description);
      }
    }
  });
}
  
function fjCartDropdownOpen(atcSuccess) {
  if($('.small--hide').css('display') == 'none' || $('.medium-up--hide').css('display') == 'block') { // mobile
    fjShowCartDropdownMobile(atcSuccess);
  } else {
    var pageScroll = $(window).scrollTop();
    if(pageScroll !== 0) {
      $('html,body').animate(
        {scrollTop: 0}, 500, function(){
          fjShowCartDropdownDesktop(atcSuccess);
        }
      );
    } else {
      fjShowCartDropdownDesktop(atcSuccess);
    }
  }
}

function fjShowCartDropdownMobile(atcSuccess) {
  $('body').addClass('cart-dropdown-open');
}

function fjShowCartDropdownDesktop(atcSuccess) {
  $('body').addClass('cart-dropdown-open');
  if(atcSuccess) {  
    var cartHang = setTimeout(function(){
      fjCartDropdownClose();
    },5000);
    $('.cart-dropdown').data('cartHang',cartHang);
    $('.cart-dropdown').mouseenter(function(){
      clearTimeout($(this).data('cartHang'));
    });
  }
}

function fjCartDropdownClose() {
  $('body').removeClass('cart-dropdown-open');
  $('.cart-dropdown .form-message').remove();
}

function fjTriggerModalClose() {
  $.fancybox.close();
}

function fjContentToggle(link) {
  var $thisLink = $(link);
  var $thisLinkText = $thisLink.find('.content-toggle__text');
  var $content = $thisLink.prev();
  var initHeight = $content.attr('data-init-height') || $content.height();  
  var fullHeight = $content.children().get(0).scrollHeight;
  var moreText = $thisLink.data('more');
  var lessText = $thisLink.data('less');
  if(!$content.hasClass('content--expanded')){
    $content.attr('data-init-height',initHeight);
    $content.addClass('content--animating');
    $content.height(initHeight).css('max-height','none').animate({
        height: fullHeight
      }, {
      duration: 500,
      complete: function() {
        $content.addClass('content--expanded').removeClass('content--animating');
        $thisLinkText.text(lessText);
      }
    });
  } else {
    $content.addClass('content--animating');
    $content.animate({
      height: initHeight
    }, {
      duration: 500,
      complete: function() {
        $content.removeClass('content--expanded content--animating');
        $thisLinkText.text(moreText);
      }
    });
  }
}

function fjAnimateAnchor(e,el) {
  e.preventDefault();
  var target = $(el).attr('href');
  var animateTo = $(target).offset().top;
  if($(el).hasClass('animate-anchor--form')) {
    animateTo = animateTo - 40;
  }
  
  $('html,body').animate({scrollTop: animateTo}, 500);
}

// Product Card Swatches
function fjProductCardSwatches(){
  $('.product-card__swatch').on('mouseover touchstart', function(){
    var swatchImg = $(this).data('swatch-img');
    if(swatchImg !== undefined) {
      var $prodImg = $(this).closest('.product-card').find('.product-card__img');
      $prodImg.attr('src',swatchImg);
    }
  });
}

// Quick View
function fjQuickViewOpen(){
  $('body').on('click', '.trigger-qv', function(){
    $.fancybox.open({
      touch: false,
      autoFocus: false,
      type: 'ajax',
      src: $(this).data('src'),
      filter: '#ProductSection-product-quick',
      afterShow: function(){
        fjQuickViewRefresh();
      }
    });
  });
}

function fjQuickViewRefresh() {
  // Reviews
  var api = new Yotpo.API(yotpo);
  api.refreshWidgets();

  // Zoom
  $('.quick-view .product-single__photo.js-zoom-enabled').each(function() {
    var $zoomImgWrapper = $(this);
    var zoomUrl = $zoomImgWrapper.data('zoom');
    $zoomImgWrapper.zoom({
      url: zoomUrl
    });
  });

  // Affirm
  affirm.ui.refresh();
}

// Nextopia Callbacks

function fjNextopiaNoResultsLoaded() {
  $('#collection-sidebar.grid__item').hide();
  $('.collection-main.grid__item').attr('style','width: 100% !important;');
  
  $('body').one('click','.finks-connect--nextopia .trigger-chat',function(){
    fjLoadChat();
  });

  $('body').on('click','.finks-connect--nextopia .trigger-chat',function(e){
    e.preventDefault();
    $('body').addClass('chat-open');
  });
}


function fjNextopiaRefinesLoaded() {
  console.log('nextopia refines loaded');
  $('body').on('click','.content-toggle',function(e){
    e.preventDefault();
    var link = this;
    fjContentToggle(link);
  });
}

function fjNextopiaCollectionLoaded() {
  console.log('nextopia collection loaded');

  // Product Card Swatches
  fjProductCardSwatches();

  // Back to Top
  $('body').on('click','.animate-anchor',function(e){
    fjAnimateAnchor(e,this);
  });

  // Reviews
  var api = new Yotpo.API(yotpo);
  api.refreshWidgets();
}

function fjNextopiaRecommendationsLoaded() {
  console.log('nextopia recommendations loaded');
  // PDP related products slider
  fjItemSlider();

  // Product Card Swatches
  fjProductCardSwatches();
}

var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
function fjCheckForGorgias(){
  if(!isIE11) {
    // Gorgias chat (doesn't work on IE11)
    var gorgiasChatInterval = window.setInterval(function () {
      if (Smooch) {
        window.clearInterval(gorgiasChatInterval); // this line breaks out of the loop - make sure it's not deleted.    
        // you can also use widget:open here's the complete list of events: https://github.com/gorgias/smooch-js#events
        Smooch.on('ready',function(){
          if($('body').hasClass('chat-open')){
          	Smooch.open();  
          }
        });
        Smooch.on('widget:closed',function() {
          $('body').removeClass('chat-open');
        });
      }
    }, 100);
  }
}

function fjLoadChat(){
  $('body').append('<div id="gorgias-chat"><script>window.gorgiasChatParameters = {}</script><script src="https://config.gorgias.io/production/ZPB9rx1kBr2WVa3O/chat/P4k1n6jDvL7reOX9.js" defer></script></div>');
  $('body').addClass('chat-open');
  fjCheckForGorgias();
}